import { useState, useEffect, useRef, useMemo } from 'react';
import { useDropzone } from 'react-dropzone';
import Layout from '../components/Layout';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from '../components/ui/dialog'; // KEEP Dialog for NEW ticket form
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Textarea } from '../components/ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../components/ui/select';
import { Badge } from '../components/ui/badge';
import { Separator } from '../components/ui/separator';
import { Plus, MessageSquare, Paperclip, Send, Calendar, Calendar1Icon, Share2 } from 'lucide-react';
import { toast } from 'sonner';
import { Trash2, Share } from "lucide-react";
import TawkMessengerReact from "@tawk.to/tawk-messenger-react";
import { db, storage } from '../firebase';
import { uploadTicketAttachmentToR2, validateAttachmentFile } from "../utils/r2upload";

import {
  collection,
  query,
  where,
  orderBy,
  onSnapshot,
  addDoc,
  updateDoc,
  doc,
  serverTimestamp,
  arrayUnion,
  getDocs,
  runTransaction,
  getDoc,
  increment,
} from 'firebase/firestore';
import { ref as storageRef, uploadBytes, getDownloadURL } from 'firebase/storage';
import StatusCards from '@/components/ui/StatusCards';
import { Popover, PopoverContent, PopoverTrigger } from '@radix-ui/react-popover';
import { cn } from '@/lib/utils';
import { DayPicker } from 'react-day-picker';
import DueDatePicker from '@/components/ui/gfd';
import { createLog } from '@/utils/createLog';

const WORKER_BASE = "https://black-firefly-4f25.secure-hyperhex.workers.dev";

// if R2 publicUrl missing, fallback to worker download endpoint
const getAttachmentUrl = (attachment) => {
  if (attachment?.url) return attachment.url;
  if (attachment?.key)
    return `${WORKER_BASE}/file?key=${encodeURIComponent(
      attachment.key
    )}`;
  return "";
};

export default function Tickets() {
  const handleBeforeLoad = () => {
    console.log("Tawk is loading");
  };
  const [user, setUser] = useState(null);
  const isSuperAdmin = user?.role === "super_admin" || user?.role === "superadmin";
  const isAdmin = user?.role === "admin" || isSuperAdmin;
  const isDeveloper = user?.role === "developer";
  const isClient = user?.role === "client";
  const [tickets, setTickets] = useState([]);
  const [projects, setProjects] = useState([]);
  const [developers, setDevelopers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [dialogOpen, setDialogOpen] = useState(false); // For NEW Ticket Form
  const [statusHoursDialogOpen, setStatusHoursDialogOpen] = useState(false);
  const [statusHoursTicketId, setStatusHoursTicketId] = useState(null);
  const [statusHoursValue, setStatusHoursValue] = useState("");
  const [statusHoursTargetStatus, setStatusHoursTargetStatus] = useState("");
  // Removed detailsDialogOpen
  const tawkRef = useRef();
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [commentText, setCommentText] = useState('');
  const [loadingAI, setLoadingAI] = useState(false);
  const [formData, setFormData] = useState({
    title: '',
    description: '',
    priority: 'Medium',
    status: 'Open',
    project_id: '',
    assigned_developer: '',
    due_date: "",
    type: 'bug'
  });
  const [filters, setFilters] = useState({
    status: "all",
    priority: "all",
    assignee: "all",
    project: "all",
    creator: "all",
    search: "",
    quick: [],   // ["my", "overdue", "critical", "unassigned"]
    type: 'all'
  });
  //   const handleDeleteTicket = async (ticket) => {
  //   if (!user || !["admin", "super_admin"].includes(user.role)) return;

  //   const confirm = window.confirm(
  //     `Are you sure you want to delete Ticket #${ticket.ticketNumber}?\n\nThis action cannot be undone.`
  //   );

  //   if (!confirm) return;

  //   try {
  //     await updateDoc(doc(db, "tickets", ticket.id), {
  //       deleted: true,
  //       deleted_at: serverTimestamp(),
  //       deleted_by: user.uid,
  //     });

  //     // OR hard delete (choose ONE)
  //     // await deleteDoc(doc(db, "tickets", ticket.id));

  //     if (selectedTicket?.id === ticket.id) {
  //       setSelectedTicket(null);
  //     }

  // await createLog({
  //   ticket,
  //   action: "deleted",
  //   message: `Ticket #${ticket.ticketNumber} deleted`,
  //   user,
  //   metadata: {
  //     ticket_id: ticket.id,
  //     ticket_number: ticket.ticketNumber,
  //     title: ticket.title,
  //     project_id: ticket.project_id || null,
  //     priority: ticket.priority,
  //     status_before_delete: ticket.status,
  //     assigned_developer: ticket.assigned_developer_name || "Unassigned",
  //     deleted_by_role: user.role,
  //     deleted_by_name: user.name,
  //     deleted_at: new Date().toISOString(),
  //     reason: "Admin deleted ticket", // optional (can be prompt later)
  //   },
  // });


  //     toast.success("Ticket deleted successfully");
  //   } catch (err) {
  //     console.error("Delete ticket error:", err);
  //     toast.error("Failed to delete ticket");
  //   }
  // };
  const handleDeleteTicket = async (ticket) => {
    if (!user || !["admin", "super_admin"].includes(user.role)) return;

    const ok = window.confirm(
      `Delete Ticket #${ticket.ticketNumber}?\n\nYou can restore it later.`
    );
    if (!ok) return;

    try {
      await updateDoc(doc(db, "tickets", ticket.id), {
        deleted: true,
        deleted_at: serverTimestamp(),
        deleted_by: user.uid,
      });

      if (selectedTicket?.id === ticket.id) {
        setSelectedTicket(null);
      }

      await createLog({
        ticket,
        action: "deleted",
        message: "Ticket deleted",
        user,
        metadata: {
          ticket_id: ticket.id,
          ticket_number: ticket.ticketNumber,
          title: ticket.title,
          project_id: ticket.project_id || null,
          priority: ticket.priority,
          status_before_delete: ticket.status,
          assigned_developer: ticket.assigned_developer_name || "Unassigned",
          deleted_by_name: user.name,
          deleted_by_role: user.role,
          deleted_at: new Date().toISOString(),
        },
      });

      toast.success("Ticket deleted");
    } catch (err) {
      console.error(err);
      toast.error("Failed to delete ticket");
    }
  };
  const handleRestoreTicket = async (ticket) => {
    if (!["admin", "super_admin"].includes(user.role)) return;

    try {
      await updateDoc(doc(db, "tickets", ticket.id), {
        deleted: false,
        deleted_at: null,
        deleted_by: null,
      });

      await createLog({
        ticket,
        action: "restored",
        message: "Ticket restored",
        user,
      });

      toast.success("Ticket restored");
    } catch (err) {
      console.error(err);
      toast.error("Failed to restore ticket");
    }
  };
  const [showDeleted, setShowDeleted] = useState(false);

  const handleAIDescription = async () => {
    if (!formData.title) {
      return toast.error("Please enter the ticket title first");
    }

    setLoadingAI(true);

    try {
      const res = await fetch("/api/generate-description", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          title: formData.title,
          extra: formData.description,
        }),
      });

      const data = await res.json();

      if (!data.result) {
        throw new Error("No AI result received");
      }

      // 🧠 Format final text (optional)
      const finalText = `
${data.result.summary}

Expected: ${data.result.expected}
Actual: ${data.result.actual}
Steps: ${data.result.steps}
Impact: ${data.result.impact}
    `.trim();

      setFormData(prev => ({
        ...prev,
        description: finalText,
      }));

      toast.success("AI description generated!");
    } catch (err) {
      console.log("AI error:", err);
      toast.error("AI generation failed");
    }

    setLoadingAI(false);
  };

  // const { getRootProps, getInputProps, acceptedFiles, reset } = useDropzone({
  //   maxFiles: 5,
  //   accept: {
  //     'image/*': ['.png', '.jpg', '.jpeg', '.gif'],
  //     'application/pdf': ['.pdf'],
  //     'application/msword': ['.doc', '.docx'],
  //   },
  // });
  const [selectedFiles, setSelectedFiles] = useState([]);
  const { getRootProps, getInputProps } = useDropzone({
    maxFiles: 5,
    accept: {
      "image/*": [".png", ".jpg", ".jpeg", ".gif", ".webp"],
      "video/*": [".mp4", ".mov", ".webm"],
      "application/pdf": [".pdf"],
      "application/msword": [".doc"],
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [".docx"],
      "application/vnd.ms-excel": [".xls"],
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"],
      "text/plain": [".txt"],
    },
    onDrop: (accepted) => {
      setSelectedFiles((prev) => {
        const updated = [...prev, ...accepted];
        return updated.slice(0, 5);
      });
    }
  });

  useEffect(() => {
    if (!dialogOpen) {
      setSelectedFiles([]);
    }
  }, [dialogOpen]);
  // keep references to unsubscribes so we can cleanup
  const unsubRefs = useRef({ tickets: null, projects: null, devs: null, ticketDoc: null });

  useEffect(() => {
    setLoading(true)
    const storedUser = JSON.parse(localStorage.getItem('user'));
    setUser(storedUser);

    if (storedUser) {
      subscribeProjects(storedUser);
      subscribeTickets(storedUser);
      // Removed the role check logic here for simplicity, assuming subscribeDevelopers handles the list load.
      subscribeDevelopers(storedUser);
    }

    return () => {
      // cleanup all listeners
      Object.values(unsubRefs.current).forEach((fn) => {
        if (typeof fn === 'function') fn();
      });
    };
  }, []);

  // -------------------------
  // Real-time tickets listener
  // -------------------------
  // const subscribeTickets = (currentUser) => {
  //   setLoading(true);

  //   let q;

  //   if (!currentUser?.uid) {
  //     console.error("User UID not found");
  //     setLoading(false);
  //     return;
  //   }

  //   const ticketsCollection = collection(db, 'tickets');

  //   if (currentUser?.role === 'developer') {
  //     // Developer sees only tickets assigned to them
  //     q = query(
  //       ticketsCollection,
  //       where('assigned_developer', '==', currentUser?.uid),
  //       orderBy('created_at', 'desc')
  //     );
  //   } else if (currentUser.role == 'client') {
  //     // Client sees only tickets they created
  //     q = query(
  //       ticketsCollection,
  //       where('created_by', '==', currentUser?.uid),
  //       orderBy('created_at', 'desc')
  //     );
  //   } else if (currentUser.role === 'admin' || currentUser.role === 'super_admin') {
  //     // Admins see all tickets
  //     q = query(ticketsCollection, orderBy('created_at', 'desc'));
  //   } else {
  //     console.error("Unknown role", currentUser.role);
  //     setLoading(false);
  //     return;
  //   }

  //   // Unsubscribe previous if exists
  //   if (unsubRefs.current.tickets) unsubRefs.current.tickets();

  //   unsubRefs.current.tickets = onSnapshot(
  //     q,
  //     (snapshot) => {
  //       const list = snapshot.docs.map((d) => ({ id: d.id, ...d.data() }));
  //       setTickets(list);
  //       setLoading(false);

  //       // Update selectedTicket if needed
  //       if (selectedTicket) {
  //         const updatedTicket = list.find(t => t.id === selectedTicket.id);
  //         if (updatedTicket) setSelectedTicket(updatedTicket);
  //       }
  //     },
  //     (err) => {
  //       console.error('tickets onSnapshot error', err);
  //       toast.error('Failed to load tickets');
  //       setLoading(false);
  //     }
  //   );
  // };
  // client ne project ni ticket mate niche no code
  const subscribeTickets = async (currentUser) => {
    setLoading(true);

    if (!currentUser?.uid) {
      console.error("User UID not found");
      setLoading(false);
      return;
    }

    const ticketsCollection = collection(db, "tickets");

    // Clear previous listeners
    Object.values(unsubRefs.current).forEach((fn) => fn && fn());
    unsubRefs.current = {};

    // TEMP memory store (only for client merging)
    let tempStore = {};

    // 🔹 Helper: Update UI
    const updateUI = (docs) => {
      docs.forEach((doc) => {
        tempStore[doc.id] = { id: doc.id, ...doc.data() };
      });

      const finalList = Object.values(tempStore).sort(
        (a, b) => b.created_at - a.created_at
      );

      setTickets(finalList);

      if (selectedTicket) {
        const updated = finalList.find((t) => t.id === selectedTicket.id);
        if (updated) setSelectedTicket(updated);
      }

      setLoading(false);
    };

    // 🔹 Helper: Handle Firestore error
    const errorHandler = (err) => {
      console.error("Firestore Error:", err);
      toast.error("Failed to load tickets");
      setLoading(false);
    };

    // ------------------------------------------------------------
    // ADMIN / SUPER ADMIN (see all tickets)
    // ------------------------------------------------------------
    const isCurrAdmin = currentUser.role === "admin" || currentUser.role === "super_admin" || currentUser.role === "superadmin";
    if (isCurrAdmin) {
      const q = query(ticketsCollection);

      unsubRefs.current.all = onSnapshot(q, (snap) => {
        tempStore = {};
        updateUI(snap.docs);
      }, errorHandler);

      return;
    }

    // ------------------------------------------------------------
    // DEVELOPER (tickets assigned to him)
    // ------------------------------------------------------------
    if (currentUser.role === "developer") {
      const q = query(
        ticketsCollection,
        where("assigned_developer", "==", currentUser.uid)
      );

      unsubRefs.current.dev = onSnapshot(q, (snap) => {
        tempStore = {};
        updateUI(snap.docs);
      }, errorHandler);

      return;
    }

    // ------------------------------------------------------------
    // CLIENT = tickets created + tickets inside his projects
    // ------------------------------------------------------------
    if (currentUser.role === "client") {
      // 1️⃣ Listen for tickets created by client
      const createdQuery = query(
        ticketsCollection,
        where("created_by", "==", currentUser.uid)
      );

      unsubRefs.current.created = onSnapshot(
        createdQuery,
        (snap) => updateUI(snap.docs),
        errorHandler
      );

      // 2️⃣ Find projects assigned to this client
      const projectQuery = query(
        collection(db, "projects"),
        where("assigned_clients", "array-contains", currentUser.uid)
      );

      const projectSnap = await getDocs(projectQuery);
      const projectIds = projectSnap.docs.map((d) => d.id);

      // No projects → stop here
      if (projectIds.length === 0) return;

      // Firestore allows only 10 items in "in" query
      const limitedProjects = projectIds.slice(0, 10);

      // 3️⃣ Listen for tickets from these projects
      const projectTicketsQuery = query(
        ticketsCollection,
        where("project_id", "in", limitedProjects)
      );

      unsubRefs.current.project = onSnapshot(
        projectTicketsQuery,
        (snap) => updateUI(snap.docs),
        errorHandler
      );

      return;
    }

    console.error("Unknown role", currentUser.role);
    setLoading(false);
  };



  // -------------------------
  // Real-time projects listener
  // -------------------------
  const subscribeProjects = async (currentUser) => {

    let q;
    if (currentUser.role === 'developer') {
      q = query(collection(db, 'projects'), where('assigned_developers', 'array-contains', currentUser.uid), orderBy('created_at', 'desc'));
      const clientProjQuery = query(
        collection(db, "projects"),
        where("assigned_developers", "array-contains", currentUser.uid)
      );

      const clientProjSnap = await getDocs(clientProjQuery);
      const clientProjList = clientProjSnap.docs.map(d => ({
        id: d.id,
        ...d.data()
      }));
      setProjects(clientProjList);
    }

    else if (currentUser.role == 'client') {
      q = query(collection(db, 'projects'), where('assigned_clients', 'array-contains', currentUser.uid), orderBy('created_at', 'desc'));
      const clientProjQuery = query(
        collection(db, "projects"),
        where("assigned_clients", "array-contains", currentUser.uid)
      );

      const clientProjSnap = await getDocs(clientProjQuery);
      const clientProjList = clientProjSnap.docs.map(d => ({
        id: d.id,
        ...d.data()
      }));
      setProjects(clientProjList);
    } else {
      // admin + super_admin -> all projects
      q = query(collection(db, 'projects'), orderBy('created_at', 'desc'));
      const clientProjQuery = query(
        collection(db, "projects"),
        where("assigned_clients", "array-contains", currentUser.uid)
      );

      const clientProjSnap = await getDocs(clientProjQuery);
      const clientProjList = clientProjSnap.docs.map(d => ({
        id: d.id,
        ...d.data()
      }));
      setProjects(clientProjList);
    }

    if (unsubRefs.current.projects) unsubRefs.current.projects();

    unsubRefs.current.projects = onSnapshot(
      q,
      (snapshot) => {
        const list = snapshot.docs.map((d) => ({ id: d.id, ...d.data() }));
        setProjects(list);
      },
      (err) => {
        toast.error('Failed to load projects');
      }
    );
  };




  // const filteredTickets = useMemo(() => {
  //   // let list = [...tickets];
  // let list = tickets.map(t => {
  //   const project = projects.find(p => p.id === t.project_id);
  //   return {
  //     ...t,
  //     projectName: project?.name?.toLowerCase() || ""
  //   };
  // });
  //   // ---- Search ----
  //   if (filters.search.trim() !== "") {
  //      const project = projects.find(p => p.id === t.project_id);
  //     const s = filters.search.toLowerCase();
  //     list = list.filter((t) =>
  //       t.title.toLowerCase().includes(s) ||
  //       t.description.toLowerCase().includes(s) ||
  //       String(t.ticketNumber).toLowerCase().includes(s) 
  //       //  t.projectName.includes(s)
  //     );
  //   }

  //   // ---- Status ----
  //   if (filters.status !== "all") {
  //     list = list.filter((t) => t.status === filters.status);
  //   }

  //   // ---- Priority ----
  //   if (filters.priority !== "all") {
  //     list = list.filter((t) => t.priority === filters.priority);
  //   }

  //   // ---- Assignee ----
  //   if (filters.assignee !== "all") {
  //     list = list.filter((t) => t.assigned_developer === filters.assignee);
  //   }

  //   // ---- Creator ----
  //   if (filters.creator !== "all") {
  //     list = list.filter((t) => t.created_by === filters.creator);
  //   }

  //   // -----------------------
  //   // QUICK FILTERS
  //   // -----------------------

  //   if (filters.quick.includes("my")) {
  //     list = list.filter(
  //       (t) =>
  //         t.assigned_developer === user.uid
  //     );
  //   }

  //   if (filters.quick.includes("overdue")) {
  //     list = list.filter(
  //       (t) => t.due_date && new Date(t.due_date) < new Date()
  //     );
  //   }

  //   if (filters.quick.includes("critical")) {
  //     list = list.filter((t) => t.priority === "High");
  //   }

  //   if (filters.quick.includes("unassigned")) {
  //     list = list.filter((t) => !t.assigned_developer);
  //   }

  //   return list;
  // }, [tickets, filters, user]);

  // -------------------------
  // Real-time developers listener
  // -------------------------
  const filteredTickets = useMemo(() => {
    // merge project name into each ticket
    let list = tickets
      .filter(t => !t.deleted) // 🔥 HIDE DELETED
      .map(t => {
        const project = projects.find(p => p.id === t.project_id);
        return {
          ...t,
          projectName: project?.name?.toLowerCase() || ""
        };
      });

    // ---- Search ----
    if (filters.search.trim() !== "") {
      const s = filters.search.toLowerCase();
      list = list.filter((t) =>
        t.title.toLowerCase().includes(s) ||
        t.description.toLowerCase().includes(s) ||
        (t.ticketNumber && t.ticketNumber.toString().includes(s)) ||
        t.projectName.includes(s)
      );
    }

    // ---- Status ----
    if (filters.status !== "all") {
      list = list.filter((t) => t.status === filters.status);
    }
    // ---- Project ----
    if (filters.project !== "all") {
      list = list.filter(
        (t) => t.project_id === filters.project
      );
    }

    // ---- Priority ----
    if (filters.priority !== "all") {
      list = list.filter((t) => t.priority === filters.priority);
    }

    // ---- Assignee ----
    if (filters.assignee !== "all") {
      list = list.filter((t) => t.assigned_developer === filters.assignee);
    }

    // ---- Creator ----
    if (filters.creator !== "all") {
      list = list.filter((t) => t.created_by === filters.creator);
    }
    // type
    if (filters.type && filters.type !== "all") {
      list = list.filter((t) => t.type == filters.type);
    }
    // -----------------------
    // QUICK FILTERS
    // -----------------------

    if (filters.quick.includes("my")) {
      list = list.filter((t) => t.assigned_developer === user.uid);
    }

    if (filters.quick.includes("overdue")) {
      list = list.filter((t) => t.due_date && new Date(t.due_date) < new Date());
    }

    if (filters.quick.includes("critical")) {
      list = list.filter((t) => t.priority === "High");
    }

    if (filters.quick.includes("unassigned")) {
      list = list.filter((t) => !t.assigned_developer);
    }

    return list;
  }, [tickets, filters, user, projects]);

  const subscribeDevelopers = () => {
    const q = query(collection(db, 'users'), orderBy('createdAt', 'desc'));
    if (unsubRefs.current.devs) unsubRefs.current.devs();
    unsubRefs.current.devs = onSnapshot(
      q,
      (snapshot) => {
        const list = snapshot.docs.map((d) => ({ id: d.id, ...d.data() }));
        setDevelopers(list);
      },
      (err) => {
      }
    );
  };

  // -------------------------
  // Create ticket + upload attachments
  // -------------------------
  const handleCreateTicket = async (e) => {
    e.preventDefault();

    if (!user) return toast.error("User not found");

    try {
      // 1. Create Ticket in Firestore ticketCount
      const countRef = doc(db, "ticketCount", "count");
      const countSnap = await getDoc(countRef);

      let ticketNumber = 1;

      if (countSnap.exists()) {
        ticketNumber = countSnap.data().ticket_count + 1; // next number
      }

      console.log("Next Ticket Number:", ticketNumber);

      // -------------------------------------------
      // 2. UPDATE COUNT (+1)
      // -------------------------------------------
      await updateDoc(countRef, {
        ticket_count: increment(1),
      });

      const selectedDev = developers.find(d => d.id === formData.assigned_developer);
      const newTicket = {
        title: formData.title,
        ticketNumber,
        type: formData.type,
        description: formData.description,
        priority: formData.priority,
        status: formData.status,
        project_id: formData.project_id,
        assigned_developer: formData.assigned_developer || "",
        created_by: user.uid,
        assigned_developer_name: selectedDev?.name || "",
        created_at: serverTimestamp(),
        created_by_name: user.name,
        comments: [],
        attachments: [],
        due_date: formData.due_date,
      };

      const docRef = await addDoc(collection(db, "tickets"), newTicket);

      // 2. Upload files
      // if (acceptedFiles.length > 0) {
      //   const uploadedFiles = [];

      //   for (const file of acceptedFiles) {
      //     const fileRef = storageRef(storage, `tickets/${docRef.id}/${file.name}`);
      //     await uploadBytes(fileRef, file);
      //     const url = await getDownloadURL(fileRef);

      //     uploadedFiles.push({
      //       name: file.name,
      //       url,
      //       uploaded_at: serverTimestamp(),
      //     });
      //   }

      //   // update ticket document with attachments array
      //   await updateDoc(doc(db, "tickets", docRef.id), {
      //     attachments: arrayUnion(...uploadedFiles)
      //   });
      // }
      // 2) Upload files to Cloudflare R2 (via Worker)
      // 2) Upload files to Cloudflare R2 (via Worker)
      if (selectedFiles.length > 0) {
        const uploadedFiles = [];

        for (const file of selectedFiles) {
          const errorMsg = validateAttachmentFile(file);
          if (errorMsg) {
            toast.error(`${file.name}: ${errorMsg}`);
            continue;
          }

          try {
            const uploaded = await uploadTicketAttachmentToR2(file, {
              ticketNumber,
              ticketTitle: formData.title,
            });

            uploadedFiles.push({
              name: file.name,
              storedName: uploaded.storedName || "",
              url: uploaded.url || "",
              key: uploaded.key,
              type: uploaded.type,
              mime: uploaded.mime,
              size: uploaded.size,
            });
          } catch (err) {
            console.error("Upload failed for", file.name, err);
            toast.error(`Upload failed: ${file.name}`);
          }
        }

        if (uploadedFiles.length > 0) {
          await updateDoc(doc(db, "tickets", docRef.id), {
            attachments: arrayUnion(...uploadedFiles),
            updated_at: serverTimestamp(), // ✅ serverTimestamp only here
          });
        }
      }


      await createLog({
        ticket: { id: docRef.id, ticketNumber },
        action: "created",
        message: "Ticket created",
        user,
      });
      toast.success("Ticket created successfully");

      // reset form
      setFormData({
        title: "",
        description: "",
        priority: "Medium",
        status: "Open",
        project_id: "",
        assigned_developer: "",
        due_date: "",
        type: 'bug'
      });
      setSelectedFiles([]);
      setDialogOpen(false);

    } catch (error) {
      console.log(error);
      toast.error("Failed to create ticket");
    }
  };


  // -------------------------
  // Open ticket details (Now just sets the ticket for display)
  // -------------------------
  const openTicketDetails = (ticket) => {
    // We rely on the main tickets listener to keep selectedTicket updated
    setSelectedTicket(ticket);
    // You might want to scroll the detail view into focus here if using smaller screens
  };

  // -------------------------
  // Add comment (atomic)
  // -------------------------
  // const handleAddComment = async () => {
  //   if (!commentText.trim()) return;

  //   try {
  //     const isResolved = selectedTicket.status === "Resolved";
  //     const isdeployed = selectedTicket.status == "Deployed";
  //     const userComment = {
  //       id: Date.now().toString(),
  //       text: commentText,
  //       user_name: user.name,
  //       user_role: user.role,
  //       timestamp: new Date().toISOString(),
  //     };

  //     const updates = {
  //       comments: arrayUnion(userComment),
  //     };

  //     const logs = [
  //       {
  //         ticket: selectedTicket,
  //         action: "comment",
  //         message: "Comment added",
  //         user,
  //       },
  //     ];

  //     // 🔥 IF RESOLVED → REOPEN
  //     if (isResolved || isdeployed) {
  //       const reopenComment = {
  //         id: (Date.now() + 1).toString(),
  //         text: "Ticket reopened due to new comment",
  //         user_name: "System",
  //         user_role: "system",
  //         timestamp: new Date().toISOString(),
  //         system: true,
  //       };

  //       updates.status = "Open"; // or "In Progress"
  //       updates.updated_at = serverTimestamp();
  //       updates.comments = arrayUnion(userComment, reopenComment);

  //       logs.push({
  //         ticket: selectedTicket,
  //         action: "reopened",
  //         message: "Ticket reopened due to new comment",
  //         user,
  //         metadata: {
  //           previous_status: "Resolved",
  //         },
  //       });
  //     }

  //     // 🔥 FIRESTORE UPDATE
  //     await updateDoc(doc(db, "tickets", selectedTicket.id), updates);

  //     // 🔥 UI UPDATE (instant)
  //     setSelectedTicket(prev => ({
  //       ...prev,
  //       status: isResolved || isdeployed ? "Open" : prev.status,
  //       comments: [...(prev.comments || []), userComment],
  //     }));

  //     logs.forEach(l => createLog(l));

  //     setCommentText("");
  //   } catch (error) {
  //     console.error("Error adding comment:", error);
  //     toast.error("Failed to add comment");
  //   }
  // };
  const handleAddComment = async (isInternal = false) => {
    if (!commentText.trim()) return;

    try {
      const isResolved = selectedTicket?.status === "Resolved";
      const isDeployed = selectedTicket?.status === "Deployed";
      const commentIsInternal = user?.role !== "client" && isInternal;

      const userComment = {
        id: Date.now().toString(),
        text: commentText.trim(),
        user_name: user?.name || "Unknown",
        user_role: user?.role || "user",
        timestamp: new Date().toISOString(),
        is_internal: commentIsInternal,
      };

      const updates = {
        comments: arrayUnion(userComment),
        updated_at: serverTimestamp(),
      };

      const logs = [
        {
          ticket: selectedTicket,
          action: "comment",
          message: commentIsInternal ? "Internal comment added" : "Comment added",
          user,
        },
      ];

      let reopenComment = null;

      // ✅ IF RESOLVED or DEPLOYED → REOPEN (only if not internal)
      if ((isResolved || isDeployed) && !commentIsInternal) {
        reopenComment = {
          id: (Date.now() + 1).toString(),
          text: "Ticket reopened due to new comment",
          user_name: "System",
          user_role: "system",
          timestamp: new Date().toISOString(),
          system: true,
        };

        updates.status = "Open"; // or "In Progress"
        updates.comments = arrayUnion(userComment, reopenComment);

        logs.push({
          ticket: selectedTicket,
          action: "reopened",
          message: "Ticket reopened due to new comment",
          user,
          metadata: {
            previous_status: selectedTicket?.status, // ✅ correct previous status
          },
        });
      }

      // ✅ FIRESTORE UPDATE
      await updateDoc(doc(db, "tickets", selectedTicket.id), updates);

      // ✅ UI UPDATE (instant)
      setSelectedTicket(prev => {
        const prevComments = prev?.comments || [];

        // If reopened -> add both user + system comment
        if ((isResolved || isDeployed) && !commentIsInternal) {
          return {
            ...prev,
            status: "Open",
            comments: [...prevComments, userComment, reopenComment],
          };
        }

        // Normal comment add
        return {
          ...prev,
          comments: [...prevComments, userComment],
        };
      });

      // ✅ Create logs
      logs.forEach(l => createLog(l));

      setCommentText("");
    } catch (error) {
      console.error("Error adding comment:", error);
      toast.error("Failed to add comment");
    }
  };



  const handleUpdateDeveloper = async (ticketId, newDevId) => {
    if (!user) return;

    try {
      const selectedDev = developers.find((d) => d.id === newDevId);

      const updatedFields = {
        assigned_developer: newDevId,
        assigned_developer_name: selectedDev?.name || "",
      };

      // 1️⃣ UPDATE UI INSTANTLY
      setSelectedTicket(prev =>
        prev?.id === ticketId
          ? {
            ...prev,
            ...updatedFields,
            comments: [...(prev.comments || []), comment],
          }
          : prev
      );

      const ticketRef = doc(db, "tickets", ticketId);

      const comment = {
        id: Date.now().toString(),
        // text: `Developer reassigned to "${selectedDev?.name || 'Unassigned'}"`,
        text: `Developer reassigned by ${user.name} to "${selectedDev?.name || 'Unassigned'}"`,

        user_id: user.uid,
        user_name: user.name || "",
        user_role: user.role || "",
        timestamp: new Date().toISOString(),
        system: true,
      };

      // 2️⃣ UPDATE FIRESTORE
      await updateDoc(ticketRef, {
        ...updatedFields,
        updated_at: serverTimestamp(),
        comments: arrayUnion(comment),
      });
      await createLog({
        ticket: selectedTicket,
        action: "assign",
        message: `Developer assigned to ${selectedDev?.name || "Unassigned"}`,
        user,
      });

      toast.success("Developer updated!");
    } catch (err) {
      console.error("update developer error", err);
      toast.error("Failed updating developer");
    }
  };


  const calculateInProgressDuration = (ticket) => {
    if (!ticket?.comments) return 0;
    const inProgressComments = ticket.comments.filter(c => 
      c.system && (c.text === 'Status changed to "In Progress"' || c.text?.includes('Status changed to "In Progress"'))
    );
    if (inProgressComments.length === 0) return 0;
    
    // Sort to get the latest
    const sorted = [...inProgressComments].sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
    const latestInProgress = sorted[0];
    
    const start = new Date(latestInProgress.timestamp);
    const end = new Date();
    const diffMs = end - start;
    const diffHours = diffMs / (1000 * 60 * 60);
    return Math.max(0, parseFloat(diffHours.toFixed(1))); // round to 1 decimal place
  };

  const handleConfirmStatusHours = async () => {
    if (!user || !statusHoursTicketId || !statusHoursTargetStatus) return;

    try {
      const ticketRef = doc(db, "tickets", statusHoursTicketId);
      const hoursNum = parseFloat(statusHoursValue) || 0;

      const comment = {
        id: Date.now().toString(),
        text: `Status changed to "${statusHoursTargetStatus}" (took approx ${hoursNum} hours)`,
        user_id: user.uid,
        user_name: user.name || "",
        user_role: user.role || "",
        timestamp: new Date().toISOString(),
        system: true,
      };

      const updatePayload = {
        status: statusHoursTargetStatus,
        updated_at: serverTimestamp(),
        comments: arrayUnion(comment),
      };

      if (statusHoursTargetStatus === "Deployed") {
        updatePayload.deployed_hours = hoursNum;
      } else if (statusHoursTargetStatus === "Resolved") {
        updatePayload.resolved_hours = hoursNum;
      }

      await updateDoc(ticketRef, updatePayload);

      // Update selectedTicket instantly in UI if it's the one currently open
      if (selectedTicket?.id === statusHoursTicketId) {
        setSelectedTicket(prev => {
          const updated = {
            ...prev,
            status: statusHoursTargetStatus,
            comments: [...(prev?.comments || []), comment],
          };
          if (statusHoursTargetStatus === "Deployed") {
            updated.deployed_hours = hoursNum;
          } else if (statusHoursTargetStatus === "Resolved") {
            updated.resolved_hours = hoursNum;
          }
          return updated;
        });
      }

      await createLog({
        ticket: selectedTicket?.id === statusHoursTicketId ? selectedTicket : { id: statusHoursTicketId },
        action: "status",
        message: `Status changed to ${statusHoursTargetStatus} (${hoursNum} hrs)`,
        user,
        metadata: {
          old_status: selectedTicket?.id === statusHoursTicketId ? selectedTicket.status : "",
          new_status: statusHoursTargetStatus,
          hours: hoursNum,
        },
      });

      toast.success("Status updated successfully");
      setStatusHoursDialogOpen(false);
      setStatusHoursTicketId(null);
      setStatusHoursTargetStatus("");
    } catch (err) {
      console.error(err);
      toast.error(`Failed to update status to ${statusHoursTargetStatus}`);
    }
  };

  const handleUpdateStatus = async (ticketId, newStatus) => {
    if (!user) return;

    if ((newStatus === "Deployed" || newStatus === "Resolved") && user?.role !== "client") {
      const ticketToDeploy = tickets.find(t => t.id === ticketId);
      const calculatedHours = calculateInProgressDuration(ticketToDeploy);
      setStatusHoursTicketId(ticketId);
      setStatusHoursTargetStatus(newStatus);
      setStatusHoursValue(calculatedHours.toString());
      setStatusHoursDialogOpen(true);
      return;
    }

    try {
      const ticketRef = doc(db, "tickets", ticketId);

      const comment = {
        id: Date.now().toString(),
        text: `Status changed to "${newStatus}"`,
        user_id: user.uid,
        user_name: user.name || "",
        user_role: user.role || "",
        timestamp: new Date().toISOString(),
        system: true,
      };

      // 🔥 Update Firestore
      await updateDoc(ticketRef, {
        status: newStatus,
        updated_at: serverTimestamp(),
        comments: arrayUnion(comment),
      });
      await createLog({
        ticket: selectedTicket,
        action: "status",
        message: `Status changed to "${newStatus}"`,
        user,
        metadata: {
          old_status: selectedTicket.status,
          new_status: newStatus,
        },
      });
      // 🔥 Update UI instantly
      setSelectedTicket(prev => ({
        ...prev,
        status: newStatus,
        comments: [...(prev?.comments || []), comment],
      }));

      toast.success("Status updated!");
    } catch (err) {
      console.error("update status error", err);
      toast.error("Failed to update status");
    }
  };


  // -------------------------
  // Helper: badge colors
  // -------------------------
  const getPriorityColor = (priority) => {
    switch (priority) {
      case 'High': return 'bg-red-100 text-red-800 border-red-200';
      case 'Medium': return 'bg-yellow-100 text-yellow-800 border-yellow-200';
      case 'Low': return 'bg-green-100 text-green-800 border-green-200';
      default: return 'bg-gray-100 text-gray-800 border-gray-200';
    }
  };

  // const getStatusColor = (status) => {
  //   switch (status) {
  //     case 'Open': return 'bg-blue-100 text-blue-800';
  //     case 'In Progress': return 'bg-purple-100 text-purple-800';
  //     case 'Resolved': return 'bg-green-100 text-green-800';
  //     case 'Rejected': return 'bg-gray-100 text-gray-800';
  //     default: return 'bg-gray-100 text-gray-800';
  //   }
  // };
  const getStatusColor = (status) => {
    switch (status) {
      case "Open":
        return "bg-blue-100 text-blue-800";

      case "In Research":
        return "bg-yellow-100 text-yellow-800";

      case "In Progress":
        return "bg-purple-100 text-purple-800";

      case "Blocked":
        return "bg-red-100 text-red-800";

      case "In QA":
        return "bg-orange-100 text-orange-800";

      case "Rejected":
        return "bg-gray-200 text-gray-800";

      case "Resolved":
        return "bg-green-100 text-green-800";

      case "Deployed":
        return "bg-emerald-100 text-emerald-800";

      default:
        return "bg-gray-100 text-gray-800";
    }
  };

  const [stats, setStats] = useState()
  const toggleQuickFilter = (filter) => {
    setFilters((prev) => {
      const newQuick = prev.quick.includes(filter)
        ? prev.quick.filter((f) => f !== filter)
        : [...prev.quick, filter];

      return { ...prev, quick: newQuick };
    });
  };
  // useEffect(() => {
  //   const fetchStats = async () => {
  //     if (!user) return;

  //     let ticketsQuery;

  //     if (user.role === 'developer') {
  //       ticketsQuery = query(
  //         collection(db, 'tickets'),
  //         where('assigned_developer', '==', user.uid)
  //       );
  //     } else if (user.role === 'client') {
  //       ticketsQuery = query(
  //         collection(db, 'tickets'),
  //         where('created_by', '==', user.uid)
  //       );
  //     } else {
  //       // admin / super_admin see all tickets
  //       ticketsQuery = collection(db, 'tickets');
  //     }

  //     const ticketsSnapshot = await getDocs(ticketsQuery);
  //     const ticketsList = ticketsSnapshot.docs.map(d => ({ id: d.id, ...d.data() }));

  //     setStats({
  //       open: ticketsList.filter(t => t.status === "Open").length,
  //       inProgress: ticketsList.filter(t => t.status === "In Progress").length,
  //       resolved: ticketsList.filter(t => t.status === "Resolved").length,
  //       assignedToMe: ticketsList.filter(t => t.assigned_developer === user.uid).length,
  //     });
  //   };

  //   fetchStats();
  // }, [user]);
  useEffect(() => {
    const fetchStats = async () => {
      if (!user) return;

      try {
        const ticketsCollection = collection(db, "tickets");
        let ticketsList = [];

        // --------------------------------
        // ADMIN / SUPER ADMIN (ALL)
        // --------------------------------
        if (user.role === "admin" || user.role === "super_admin") {
          const snap = await getDocs(ticketsCollection);
          ticketsList = snap.docs.map(d => ({ id: d.id, ...d.data() }));
        }

        // --------------------------------
        // DEVELOPER (Assigned tickets)
        // --------------------------------
        else if (user.role === "developer") {
          const q = query(ticketsCollection, where("assigned_developer", "==", user.uid));
          const snap = await getDocs(q);
          ticketsList = snap.docs.map(d => ({ id: d.id, ...d.data() }));
        }

        // --------------------------------
        // CLIENT = created tickets + project tickets
        // --------------------------------
        else if (user.role === "client") {
          const temp = {};

          // 1) Tickets created by client
          const createdQuery = query(ticketsCollection, where("created_by", "==", user.uid));
          const createdSnap = await getDocs(createdQuery);
          createdSnap.docs.forEach(d => (temp[d.id] = { id: d.id, ...d.data() }));

          // 2) Tickets from client projects
          const projQuery = query(
            collection(db, "projects"),
            where("assigned_clients", "array-contains", user.uid)
          );

          const projSnap = await getDocs(projQuery);
          const projectIds = projSnap.docs.map(d => d.id);

          // Firestore "in" supports only 10 items
          const limited = projectIds.slice(0, 10);

          if (limited.length > 0) {
            const projectTicketsQuery = query(
              ticketsCollection,
              where("project_id", "in", limited)
            );

            const projTicketsSnap = await getDocs(projectTicketsQuery);
            projTicketsSnap.docs.forEach(d => (temp[d.id] = { id: d.id, ...d.data() }));
          }

          ticketsList = Object.values(temp);
        }

        // ✅ hide deleted (same like filteredTickets)
        ticketsList = ticketsList.filter(t => !t.deleted);

        // ✅ count
        setStats({
          open: ticketsList.filter(t => t.status === "Open").length,
          inProgress: ticketsList.filter(t => t.status === "In Progress").length,
          resolved: ticketsList.filter(t => t.status === "Resolved").length,
          assignedToMe: ticketsList.filter(t => t.assigned_developer === user.uid).length,
        });

      } catch (err) {
        console.error("Stats error:", err);
      }
    };

    fetchStats();
  }, [user]);

  const handleUpdateTicketContent = async (ticketId, data) => {
    try {
      const ticketRef = doc(db, "tickets", ticketId);

      // Detect hour changes
      let hourChanges = [];
      if (data.deployed_hours !== undefined && data.deployed_hours !== (selectedTicket?.deployed_hours || 0)) {
        hourChanges.push(`Deployed hours updated from ${selectedTicket?.deployed_hours || 0} to ${data.deployed_hours}`);
      }
      if (data.resolved_hours !== undefined && data.resolved_hours !== (selectedTicket?.resolved_hours || 0)) {
        hourChanges.push(`Resolved hours updated from ${selectedTicket?.resolved_hours || 0} to ${data.resolved_hours}`);
      }

      let commentText = "Ticket details updated";
      if (hourChanges.length > 0) {
        commentText += ` (${hourChanges.join(", ")})`;
      }

      const comment = {
        id: Date.now().toString(),
        text: commentText,
        user_id: user.uid,
        user_name: user.name,
        user_role: user.role,
        timestamp: new Date().toISOString(),
        system: true,
      };

      const updatePayload = {
        title: data.title,
        description: data.description,
        updated_at: serverTimestamp(),
        comments: arrayUnion(comment),
      };

      if (data.attachments !== undefined) {
        updatePayload.attachments = data.attachments;
      }

      if (data.deployed_hours !== undefined) {
        updatePayload.deployed_hours = data.deployed_hours;
      }

      if (data.resolved_hours !== undefined) {
        updatePayload.resolved_hours = data.resolved_hours;
      }

      // 🔥 Firestore update
      await updateDoc(ticketRef, updatePayload);
      await createLog({
        ticket: selectedTicket,
        action: "updated",
        message: commentText,
        user,
      });

      // 🔥 UI update instantly
      setSelectedTicket(prev => {
        const updated = {
          ...prev,
          title: data.title,
          description: data.description,
          comments: [...(prev?.comments || []), comment],
        };
        if (data.attachments !== undefined) {
          updated.attachments = data.attachments;
        }
        if (data.deployed_hours !== undefined) {
          updated.deployed_hours = data.deployed_hours;
        }
        if (data.resolved_hours !== undefined) {
          updated.resolved_hours = data.resolved_hours;
        }
        return updated;
      });

      toast.success("Ticket updated");
    } catch (err) {
      console.error(err);
      toast.error("Failed to update ticket");
    }
  };
  const shareTicket = async (ticket) => {
    const project = projects.find(p => p.id === ticket.project_id);

    let attachmentsText = "";
    if (ticket.attachments && ticket.attachments.length > 0) {
      attachmentsText = "\n\n📎 Attachments:\n" + ticket.attachments.map(att => {
        const url = getAttachmentUrl(att);
        return `- ${att.name || "File"}: ${url}`;
      }).join("\n");
    }

    const text = `
🎫 Ticket #${ticket.ticketNumber}
🔖 Title: ${ticket.title}
📌 Project: ${project?.name || "N/A"}
⚡ Priority: ${ticket.priority}
📍 Status: ${ticket.status}

📝 Description:
${ticket.description}

👤 Assigned: ${user.role === "client"
        ? "Hyperhex Developer"
        : ticket.assigned_developer_name || "Unassigned"}

📅 Created: ${ticket.created_at?.toDate?.().toLocaleString() || ""}${attachmentsText}
  `.trim();

    try {
      await navigator.clipboard.writeText(text);
      toast.success("Ticket copied for WhatsApp sharing");
    } catch (err) {
      toast.error("Failed to copy");
    }
  };
  const handleChatMaximized = () => {
    console.log("Chat opened");
  };

  const handleChatMinimized = () => {
    console.log("Chat minimized");
  };

  if (!user) return <div>Loading...</div>;

  return (
    <Layout user={user}>


      <div data-testid="tickets-page">

        <div className="flex justify-between items-center mb-8">

          <div>
            <h1 className="text-4xl font-bold" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
              Tickets
            </h1>
            <p className="text-gray-600 mt-2">Track and manage support tickets</p>
          </div>

          {/* KEEP: Dialog for New Ticket Creation Form */}
          <Dialog open={dialogOpen} onOpenChange={setDialogOpen}>
            <DialogTrigger asChild>
              <Button data-testid="create-ticket-btn">
                <Plus className="mr-2 h-4 w-4" />
                New Ticket
              </Button>
            </DialogTrigger>

            <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
              <DialogHeader>
                <DialogTitle>Create New Ticket</DialogTitle>
                <DialogDescription>Submit a new support ticket</DialogDescription>
              </DialogHeader>

              <form onSubmit={handleCreateTicket} className="space-y-4">

                <div>
                  <Label htmlFor="title">Title</Label>
                  <Input
                    id="title"
                    value={formData.title}
                    onChange={(e) => setFormData({ ...formData, title: e.target.value })}
                    required
                    data-testid="ticket-title-input"
                  />
                </div>

                <div>
                  <Label htmlFor="description">Description</Label>

                  <div className="relative">
                    <Textarea
                      id="description"
                      value={formData.description}
                      onChange={(e) =>
                        setFormData({ ...formData, description: e.target.value })
                      }
                      required
                      rows={4}
                      data-testid="ticket-description-input"
                      className="pr-28" // space to avoid overlap if button goes inside
                    />

                    {/* AI Button (Inside Textarea Area, right corner) */}
                    <button
                      type="button"
                      onClick={handleAIDescription}
                      disabled={loadingAI}
                      className="absolute bottom-2 right-2 px-2 py-1 text-xs bg-purple-600 hover:bg-purple-700 text-white rounded-md"
                    >
                      {loadingAI ? "..." : "✨ AI"}
                    </button>
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <Label htmlFor="project">Project</Label>
                    <Select value={formData.project_id} onValueChange={(value) => setFormData({ ...formData, project_id: value })}>
                      <SelectTrigger data-testid="ticket-project-select">
                        <SelectValue placeholder="Select project" />
                      </SelectTrigger>
                      <SelectContent>
                        {projects.map((project) => (
                          <SelectItem key={project.id} value={project.id}>
                            {project.name}
                          </SelectItem>
                        ))}
                      </SelectContent>
                    </Select>
                  </div>
                  <div>
                    <Label htmlFor="priority">Priority</Label>
                    <Select value={formData.priority} onValueChange={(value) => setFormData({ ...formData, priority: value })}>
                      <SelectTrigger data-testid="ticket-priority-select">
                        <SelectValue />
                      </SelectTrigger>
                      <SelectContent>
                        <SelectItem value="Low">Low</SelectItem>
                        <SelectItem value="Medium">Medium</SelectItem>
                        <SelectItem value="High">High</SelectItem>
                      </SelectContent>
                    </Select>
                  </div>
                </div>
                <div className="grid grid-cols-2 gap-4 mt-4">
                  <div>
                    <Label htmlFor="type">Ticket Type</Label>
                    <Select
                      value={formData.type || "bug"}
                      onValueChange={(value) => setFormData({ ...formData, type: value })}
                    >
                      <SelectTrigger>
                        <SelectValue placeholder="Bug" />
                      </SelectTrigger>
                      <SelectContent>
                        <SelectItem value="bug">Bug</SelectItem>
                        <SelectItem value="feature">Feature</SelectItem>
                      </SelectContent>
                    </Select>
                  </div>
                  <div>
                    <Label>Due Date</Label>
                    <div className="rounded-md border border-input bg-background text-sm ring-offset-background focus-within:outline-none focus-within:ring-2 focus-within:ring-ring focus-within:ring-offset-2 min-h-[38px] flex items-center">
                      <DueDatePicker
                        value={formData.due_date}
                        onChange={(date) =>
                          setFormData((prev) => ({
                            ...prev,
                            due_date: date ? (typeof date === 'string' ? date : (date instanceof Date ? `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}` : '')) : '',
                          }))
                        }
                      />
                    </div>
                  </div>
                </div>

                {isAdmin && developers.length > 0 && (
                  <div>
                    <Label htmlFor="developer">Assign Developer (Optional)</Label>
                    <Select
                      value={formData.assigned_developer || 'none'}
                      onValueChange={(value) =>
                        setFormData({
                          ...formData,
                          assigned_developer: value === 'none' ? '' : value,
                        })
                      }
                    >
                      <SelectTrigger data-testid="ticket-developer-select">
                        <SelectValue placeholder="Select developer" />
                      </SelectTrigger>
                      <SelectContent>
                        <SelectItem value="none">None</SelectItem>
                        {developers.map((dev) => (
                          <SelectItem key={dev.id} value={dev.id}>
                            {dev.name}
                          </SelectItem>
                        ))}
                      </SelectContent>
                    </Select>
                  </div>
                )}

                <div>
                  <Label>Attachments</Label>
                  <div
                    {...getRootProps()}
                    className="border-2 border-dashed rounded-lg p-6 text-center cursor-pointer hover:border-gray-400 transition-colors"
                  >
                    <input {...getInputProps()} />
                    <Paperclip className="mx-auto h-8 w-8 text-gray-400 mb-2" />
                    <p className="text-sm text-gray-600">Drag files here or click to browse</p>
                    <p className="text-xs text-gray-500 mt-1">PDF, DOC, Images (Max 5 files)</p>
                  </div>
                  {selectedFiles.length > 0 && (
                    <div className="mt-2 text-sm text-gray-600">
                      {selectedFiles.length} file(s) selected
                    </div>
                  )}
                </div>
                {selectedFiles.length > 0 && (
                  <div className="mt-3 space-y-2">
                    {selectedFiles.map((f, idx) => (
                      <div key={idx} className="flex justify-between items-center text-sm border rounded-md px-3 py-2">
                        <span className="truncate">{f.name}</span>
                        <div className="flex items-center space-x-2 shrink-0">
                          <span className="text-xs text-gray-500">{(f.size / 1024 / 1024).toFixed(2)} MB</span>
                          <button
                            type="button"
                            onClick={() => setSelectedFiles(prev => prev.filter((_, i) => i !== idx))}
                            className="text-red-500 hover:text-red-700 font-medium text-xs ml-2"
                          >
                            Remove
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
                <Button type="submit" className="w-full" data-testid="submit-ticket-btn">
                  Create Ticket
                </Button>
              </form>
            </DialogContent>
          </Dialog>

          <Dialog open={statusHoursDialogOpen} onOpenChange={setStatusHoursDialogOpen}>
            <DialogContent className="max-w-md">
              <DialogHeader>
                <DialogTitle>Confirm Hours for {statusHoursTargetStatus}</DialogTitle>
                <DialogDescription>
                  Enter the approximate hours spent on this ticket from In Progress to {statusHoursTargetStatus}.
                </DialogDescription>
              </DialogHeader>

              <div className="space-y-4 py-4">
                <div className="space-y-2">
                  <Label htmlFor="status-hours">Approximate Hours</Label>
                  <Input
                    id="status-hours"
                    type="number"
                    step="0.1"
                    min="0"
                    value={statusHoursValue}
                    onChange={(e) => setStatusHoursValue(e.target.value)}
                    placeholder="e.g. 4.5"
                  />
                </div>
              </div>

              <div className="flex justify-end space-x-2">
                <Button variant="outline" onClick={() => setStatusHoursDialogOpen(false)}>
                  Cancel
                </Button>
                <Button onClick={handleConfirmStatusHours}>
                  Confirm & Update
                </Button>
              </div>
            </DialogContent>
          </Dialog>
        </div>
        {stats && <StatusCards
          stats={{
            open: stats?.open || 0,
            inProgress: stats?.inProgress || 0,
            resolved: stats?.resolved || 0,
            assignedToMe: stats?.assignedToMe || 0
          }}
        />}
        {isAdmin && <div className="p-4 bg-white border rounded-lg mb-4">
          <h3 className="font-medium mb-3 text-sm flex items-center gap-2">
            <span>Advanced Filters</span>
            {(filters.status !== "all" || filters.priority !== "all" ||
              filters.assignee !== "all" || filters.creator !== "all") && (
                <Badge className="bg-blue-600 text-white">Active</Badge>
              )}
          </h3>

          <div className="p-4 bg-white border rounded-lg mb-4">
            <h3 className="font-medium mb-3 text-sm flex items-center gap-2">
              <span>Advanced Filters</span>
            </h3>

            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">

              {/* Status */}
              <div>
                <Label>Status</Label>
                <Select
                  value={filters.status}
                  onValueChange={(v) => setFilters(p => ({ ...p, status: v }))}
                >
                  <SelectTrigger>
                    <SelectValue />
                  </SelectTrigger>
                  {/* <SelectContent>
                    <SelectItem value="all">All</SelectItem>
                    <SelectItem value="Open">Open</SelectItem>
                    <SelectItem value="In Progress">In Progress</SelectItem>
                    <SelectItem value="Resolved">Resolved</SelectItem>
                    <SelectItem value="Rejected">Rejected</SelectItem>
                  </SelectContent> */}
                  <SelectContent>
                    <SelectItem value="all">All</SelectItem>
                    <SelectItem value="Open">Open</SelectItem>
                    <SelectItem value="In Research">In Research</SelectItem>
                    <SelectItem value="In Progress">In Progress</SelectItem>
                    <SelectItem value="Blocked">Blocked</SelectItem>
                    <SelectItem value="In QA">In QA</SelectItem>
                    <SelectItem value="Rejected">Rejected</SelectItem>
                    <SelectItem value="Resolved">Resolved</SelectItem>
                    <SelectItem value="Deployed">Deployed</SelectItem>
                  </SelectContent>
                </Select>
              </div>

              {/* Priority */}
              <div>
                <Label>Priority</Label>
                <Select
                  value={filters.priority}
                  onValueChange={(v) => setFilters(p => ({ ...p, priority: v }))}
                >
                  <SelectTrigger>
                    <SelectValue />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="all">All</SelectItem>
                    <SelectItem value="High">High</SelectItem>
                    <SelectItem value="Medium">Medium</SelectItem>
                    <SelectItem value="Low">Low</SelectItem>
                  </SelectContent>
                </Select>
              </div>

              {/* Type */}
              <div>
                <Label>Type</Label>
                <Select
                  value={filters.type}
                  onValueChange={(v) => setFilters(p => ({ ...p, type: v }))}
                >
                  <SelectTrigger>
                    <SelectValue />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="all">All</SelectItem>
                    <SelectItem value="bug">Bug</SelectItem>
                    <SelectItem value="feature">Feature</SelectItem>
                  </SelectContent>
                </Select>
              </div>

              {/* Project */}
              <div>
                <Label>Project</Label>
                <Select
                  value={filters.project}
                  onValueChange={(v) => setFilters(p => ({ ...p, project: v }))}
                >
                  <SelectTrigger>
                    <SelectValue placeholder="All Projects" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="all">All</SelectItem>
                    {projects.map(p => (
                      <SelectItem key={p.id} value={p.id}>
                        {p.name}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </div>

              {/* Assignee */}
              <div>
                <Label>Assignee</Label>
                <Select
                  value={filters.assignee}
                  onValueChange={(v) => setFilters(p => ({ ...p, assignee: v }))}
                >
                  <SelectTrigger>
                    <SelectValue />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="all">All</SelectItem>
                    {developers.map(dev => (
                      <SelectItem key={dev.id} value={dev.id}>
                        {dev.name}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </div>

              {/* Creator */}
              <div>
                <Label>Creator</Label>
                <Select
                  value={filters.creator}
                  onValueChange={(v) => setFilters(p => ({ ...p, creator: v }))}
                >
                  <SelectTrigger>
                    <SelectValue />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="all">All</SelectItem>
                    {developers.map(dev => (
                      <SelectItem key={dev.id} value={dev.id}>
                        {dev.name}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </div>

            </div>
          </div>

        </div>}

        {/* for developers */}
        {(!isAdmin) && <div className="p-4 bg-white border rounded-lg mb-4">
          <h3 className="font-medium mb-3 text-sm flex items-center gap-2">
            <span>Advanced Filters</span>
            {(filters.status !== "all" || filters.priority !== "all" ||
              filters.assignee !== "all" || filters.creator !== "all") && (
                <Badge className="bg-blue-600 text-white">Active</Badge>
              )}
          </h3>

          <div className="p-4 bg-white border rounded-lg mb-4">
            <h3 className="font-medium mb-3 text-sm flex items-center gap-2">
              <span>Advanced Filters</span>
            </h3>

            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">

              {/* Status */}
              <div>
                <Label>Status</Label>
                <Select
                  value={filters.status}
                  onValueChange={(v) => setFilters(p => ({ ...p, status: v }))}
                >
                  <SelectTrigger>
                    <SelectValue />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="all">All</SelectItem>
                    <SelectItem value="Open">Open</SelectItem>
                    <SelectItem value="In Research">In Research</SelectItem>
                    <SelectItem value="In Progress">In Progress</SelectItem>
                    <SelectItem value="Blocked">Blocked</SelectItem>
                    <SelectItem value="In QA">In QA</SelectItem>
                    <SelectItem value="Rejected">Rejected</SelectItem>
                    <SelectItem value="Resolved">Resolved</SelectItem>
                    <SelectItem value="Deployed">Deployed</SelectItem>
                  </SelectContent>
                </Select>
              </div>

              {/* Priority */}
              <div>
                <Label>Priority</Label>
                <Select
                  value={filters.priority}
                  onValueChange={(v) => setFilters(p => ({ ...p, priority: v }))}
                >
                  <SelectTrigger>
                    <SelectValue />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="all">All</SelectItem>
                    <SelectItem value="High">High</SelectItem>
                    <SelectItem value="Medium">Medium</SelectItem>
                    <SelectItem value="Low">Low</SelectItem>
                  </SelectContent>
                </Select>
              </div>

              {/* Type */}
              <div>
                <Label>Type</Label>
                <Select
                  value={filters.type}
                  onValueChange={(v) => setFilters(p => ({ ...p, type: v }))}
                >
                  <SelectTrigger>
                    <SelectValue />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="all">All</SelectItem>
                    <SelectItem value="bug">Bug</SelectItem>
                    <SelectItem value="feature">Feature</SelectItem>
                  </SelectContent>
                </Select>
              </div>

              {/* Project */}
              <div>
                <Label>Project</Label>
                <Select
                  value={filters.project}
                  onValueChange={(v) => setFilters(p => ({ ...p, project: v }))}
                >
                  <SelectTrigger>
                    <SelectValue placeholder="All Projects" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="all">All</SelectItem>
                    {projects.map(p => (
                      <SelectItem key={p.id} value={p.id}>
                        {p.name}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </div>



            </div>
          </div>

        </div>}
        <div className="flex flex-wrap gap-2 mb-3">
          {filters.status !== "all" && (
            <Badge onClick={() => setFilters(p => ({ ...p, status: "all" }))}>
              Status: {filters.status} ✕
            </Badge>
          )}

          {filters.priority !== "all" && (
            <Badge onClick={() => setFilters(p => ({ ...p, priority: "all" }))}>
              Priority: {filters.priority} ✕
            </Badge>
          )}

          {filters.assignee !== "all" && (
            <Badge onClick={() => setFilters(p => ({ ...p, assignee: "all" }))}>
              Assignee ✕
            </Badge>
          )}

          {filters.creator !== "all" && (
            <Badge onClick={() => setFilters(p => ({ ...p, creator: "all" }))}>
              Creator ✕
            </Badge>
          )}

          {filters.quick.map((q) => (
            <Badge key={q} onClick={() => toggleQuickFilter(q)}>
              {q} ✕
            </Badge>
          ))}
        </div>

        <div className="flex items-center gap-2 mb-4">
          <span className="font-medium text-sm">Quick Filters:</span>

          <Button
            variant={filters.quick.includes("my") ? "default" : "outline"}
            size="sm"
            onClick={() => toggleQuickFilter("my")}
          >
            My Tickets
          </Button>

          <Button
            variant={filters.quick.includes("overdue") ? "default" : "outline"}
            size="sm"
            onClick={() => toggleQuickFilter("overdue")}
          >
            Overdue
          </Button>

          <Button
            variant={filters.quick.includes("critical") ? "default" : "outline"}
            size="sm"
            onClick={() => toggleQuickFilter("critical")}
          >
            Critical
          </Button>

          <Button
            variant={filters.quick.includes("unassigned") ? "default" : "outline"}
            size="sm"
            onClick={() => toggleQuickFilter("unassigned")}
          >
            Unassigned
          </Button>
        </div>
        <Input
          placeholder="Search tickets by title, description, assignee, creator..."
          value={filters.search}
          onChange={(e) => setFilters((p) => ({ ...p, search: e.target.value }))}
          className="mb-4"
        />
        {/* --- MAIN TWO-COLUMN LAYOUT START --- */}
        {loading ? (
          <div className="text-center py-12">Loading tickets...</div>
        ) : tickets.length === 0 ? (
          <Card>
            <CardContent className="py-12 text-center">
              <p className="text-gray-500">No tickets found. Create your first ticket!</p>
            </CardContent>
          </Card>
        ) : (
          <div className="flex h-[75vh] border rounded-xl overflow-hidden shadow-lg">

            {/* LEFT COLUMN: Ticket List (Fixed width 40%) */}
            <div className="w-2/5 border-r overflow-y-auto bg-gray-50 p-2">
              <h3 className="text-lg font-bold p-2 text-gray-700">All Tickets ({tickets.length})</h3>
              <Separator className="mb-4" />
              <div className="space-y-3 pr-2">
                {filteredTickets.map((ticket) => {
                  const project = projects.find((p) => p.id === ticket.project_id);

                  return (
                    <Card className={`cursor-pointer shadow-sm hover:shadow-md transition-all
    ${ticket.type == "feature" ? "border-2 border-blue-300" : "border"}
    ${selectedTicket?.id === ticket.id ? "bg-blue-50/50" : ""}
  `} onClick={() => openTicketDetails(ticket)}>


                      <div className="p-4">

                        {/* Top row: Title + Status */}
                        <div className="flex justify-between items-start">
                          <div>
                            <p className="text-sm text-gray-500">#{ticket?.ticketNumber || ""}</p>

                            <h2 className="text-lg font-semibold">{ticket.title}</h2>

                            {/* Project name */}
                            <p className="text-sm text-gray-500">({project?.name || "Unknown"})</p>
                          </div>

                          {/* Status badge */}
                          <div className="flex flex-col items-end gap-1">
                            {/* Status */}
                            <Badge className={getStatusColor(ticket.status)}>
                              {ticket.status}
                            </Badge>

                            {/* Actions */}
                            <div className="flex items-center gap-1">
                              {/* Share */}
                              <Button
                                size="icon"
                                variant="ghost"
                                className="h-7 w-7 text-gray-400 hover:text-green-600"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  shareTicket(ticket);
                                }}
                                title="Share"
                              >
                                <Share2 className="h-4 w-4" />
                              </Button>

                              {/* Delete (Admin only) */}
                              {(user.role === "admin" || user.role === "super_admin") && (
                                <Button
                                  size="icon"
                                  variant="ghost"
                                  className="h-7 w-7 text-gray-400 hover:text-red-600"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleDeleteTicket(ticket);
                                  }}
                                  title="Delete Ticket"
                                >
                                  <Trash2 className="h-4 w-4" />
                                </Button>
                              )}
                            </div>
                          </div>


                        </div>

                        {/* Description */}
                        <p className="text-sm text-gray-600 mt-2 line-clamp-2">Description: {ticket.description}</p>


                        {/* Bottom row */}
                        <div className="flex justify-between items-end mt-2">

                          {/* Assigned */}
                          <p className="text-xs text-gray-500">
                            Assigned: <span className="font-medium">{user.role == 'client' ? "ht-dev" : ticket.assigned_developer_name || "N/A"}</span>
                          </p>

                          {/* Priority + Date */}
                          <div className="flex items-center gap-2">
                            <Badge variant="outline" className={getPriorityColor(ticket.priority)}>
                              {ticket.priority}
                            </Badge>

                            <p className="text-[12px] text-gray-500">
                              {ticket?.created_at?.toDate().toLocaleString("en-IN", {
                                day: "2-digit",
                                month: "2-digit",
                                year: "2-digit",
                                hour: "numeric",
                                minute: "2-digit",
                              })}
                            </p>
                          </div>
                        </div>

                      </div>
                    </Card>

                  );
                })}
              </div>
            </div>

            {/* RIGHT COLUMN: Ticket Details (Remaining 60%) */}
            <div className="w-3/5 overflow-y-auto p-6 bg-white">
              {selectedTicket ? (
                <TicketDetails
                  selectedTicket={selectedTicket}
                  handleUpdateTicketContent={handleUpdateTicketContent}
                  user={user}
                  developers={developers}
                  handleUpdateDeveloper={handleUpdateDeveloper}
                  handleUpdateStatus={handleUpdateStatus}
                  commentText={commentText}
                  setCommentText={setCommentText}
                  handleAddComment={handleAddComment}
                  getPriorityColor={getPriorityColor}
                  getStatusColor={getStatusColor}
                />
              ) : (
                <div className="text-center py-20 text-gray-500">
                  <MessageSquare className="mx-auto h-12 w-12 mb-4" />
                  Select a ticket from the left to view details and discussion.
                </div>
              )}
            </div>
          </div>
        )}
        <TawkMessengerReact
          propertyId="694eaef9a66b8d197ba841d8"
          widgetId="1jddlmvu4"
          onLoad={() => { }}
          onStatusChange={() => { }}
          onChatStarted={() => { }}
          onBeforeLoad={() => { }}
          onChatMaximized={() => { }}
          onChatMinimized={() => { }}
          ref={tawkRef}
        />
        {/* --- MAIN TWO-COLUMN LAYOUT END --- */}
      </div>
    </Layout>
  );
}

// useEffect(() => {
//   // Prevent duplicate load
//   if (window.Tawk_API) return;

//   var Tawk_API = window.Tawk_API || {};
//   var Tawk_LoadStart = new Date();

//   const script = document.createElement("script");
//   script.async = true;
//   script.src = "https://embed.tawk.to/694eac725585f019809e773b/1jddl37uk";
//   script.charset = "UTF-8";
//   script.setAttribute("crossorigin", "*");

//   document.body.appendChild(script);

//   return () => {
//     // Optional cleanup if you want chat removed on page leave
//     document.body.removeChild(script);
//   };
// }, []);

// -------------------------------------------------------------
// NEW: Standalone Component for Ticket Details (for cleanliness)
// -------------------------------------------------------------
const TicketDetails = ({
  selectedTicket,
  user,
  developers,
  handleUpdateDeveloper,
  handleUpdateStatus,
  commentText,
  setCommentText,
  handleUpdateTicketContent,
  handleAddComment,
  getPriorityColor,
  getStatusColor
}) => {
  const isSuperAdmin = user?.role === "super_admin" || user?.role === "superadmin";
  const isAdmin = user?.role === "admin" || isSuperAdmin;
  const isDeveloper = user?.role === "developer";
  const isClient = user?.role === "client";

  const [isInternalComment, setIsInternalComment] = useState(false);

  const visibleComments = useMemo(() => {
    if (!selectedTicket?.comments) return [];
    return [...selectedTicket.comments]
      .filter((comment) => {
        if (comment.is_internal) {
          return user?.role !== "client";
        }
        return true;
      })
      .map((comment) => {
        if (user?.role === "client") {
          let text = comment.text || "";
          // Strip took approx hours part
          text = text.replace(/\s*\(took approx [\d.]+(?: hours)?\)/gi, "");
          text = text.replace(/\s*\([\d.]+\s*hrs\)/gi, "");
          // Strip edit detail hour logs
          text = text.replace(/\s*\((?:Deployed|Resolved)\s+hours\s+updated\s+from\s+[\d.]+\s+to\s+[\d.]+\)/gi, "");
          text = text.replace(/\s*\((?:Deployed|Resolved)\s+hours\s+updated\s+from\s+[\d.]+\s+to\s+[\d.]+,\s*(?:Deployed|Resolved)\s+hours\s+updated\s+from\s+[\d.]+\s+to\s+[\d.]+\)/gi, "");
          return { ...comment, text };
        }
        return comment;
      })
      .sort((a, b) => new Date(a.timestamp) - new Date(b.timestamp));
  }, [selectedTicket?.comments, user?.role]);

  const formatBytes = (bytes = 0) => {
    if (!bytes) return "";
    const sizes = ["B", "KB", "MB", "GB"];
    const i = Math.floor(Math.log(bytes) / Math.log(1024));
    return `${(bytes / Math.pow(1024, i)).toFixed(2)} ${sizes[i]}`;
  };
  // Helper function to format timestamp
  const formatTimestamp = (timestamp) => {
    if (timestamp?.toDate) {
      return timestamp?.toDate().toLocaleString();
    }
    if (typeof timestamp === 'string') {
      return new Date(timestamp).toLocaleString();
    }
    return 'N/A';
  };
  // who can edit projects
  const canEditTicket =
    isAdmin ||
    user.uid === selectedTicket.created_by;
  const [isEditing, setIsEditing] = useState(false);
  const [editData, setEditData] = useState({
    title: selectedTicket.title,
    description: selectedTicket.description,
    deployed_hours: selectedTicket.deployed_hours || 0,
    resolved_hours: selectedTicket.resolved_hours || 0,
  });
  const [attachmentsList, setAttachmentsList] = useState([]);
  const [newFiles, setNewFiles] = useState([]);
  const [isSaving, setIsSaving] = useState(false);

  const { getRootProps: getEditRootProps, getInputProps: getEditInputProps } = useDropzone({
    maxFiles: 5,
    accept: {
      "image/*": [".png", ".jpg", ".jpeg", ".gif", ".webp"],
      "video/*": [".mp4", ".mov", ".webm"],
      "application/pdf": [".pdf"],
      "application/msword": [".doc"],
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [".docx"],
      "application/vnd.ms-excel": [".xls"],
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"],
      "text/plain": [".txt"],
    },
    onDrop: (accepted) => {
      setNewFiles((prev) => {
        const updated = [...prev, ...accepted];
        return updated.slice(0, 5);
      });
    }
  });

  useEffect(() => {
    setEditData({
      title: selectedTicket.title,
      description: selectedTicket.description,
      deployed_hours: selectedTicket.deployed_hours || 0,
      resolved_hours: selectedTicket.resolved_hours || 0,
    });
    setNewFiles([]);
    setAttachmentsList(selectedTicket.attachments || []);
    setIsEditing(false);
  }, [selectedTicket.id]);

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-start border-b pb-4">
        {/* <h2 className="text-3xl font-bold pr-8">{selectedTicket.title}</h2> */}
        <div >
          {isEditing ? (
            <Input
              value={editData.title}
              onChange={(e) =>
                setEditData(p => ({ ...p, title: e.target.value }))
              }
            />
          ) : (
            <h2 className="text-3xl font-bold pr-8 mb-2">{selectedTicket.title}</h2>
          )}

          {canEditTicket && !isEditing && (
            <Button
              size="sm"
              variant="outline"
              onClick={() => setIsEditing(true)}
            >
              Edit
            </Button>
          )}

          {isEditing && (
            <div className="flex gap-2 mt-2">
              <Button
                disabled={isSaving}
                onClick={async () => {
                  setIsSaving(true);
                  try {
                    let updatedAttachments = [...attachmentsList];
                    if (newFiles.length > 0) {
                      const uploadedFiles = [];
                      for (const file of newFiles) {
                        const errorMsg = validateAttachmentFile(file);
                        if (errorMsg) {
                          toast.error(`${file.name}: ${errorMsg}`);
                          continue;
                        }
                        const uploaded = await uploadTicketAttachmentToR2(file, {
                          ticketNumber: selectedTicket.ticketNumber,
                          ticketTitle: editData.title,
                        });
                        uploadedFiles.push({
                          name: file.name,
                          storedName: uploaded.storedName || "",
                          url: uploaded.url || "",
                          key: uploaded.key,
                          type: uploaded.type,
                          mime: uploaded.mime,
                          size: uploaded.size,
                        });
                      }
                      updatedAttachments = [...updatedAttachments, ...uploadedFiles];
                    }

                    await handleUpdateTicketContent(selectedTicket.id, {
                      ...editData,
                      attachments: updatedAttachments,
                    });
                    setNewFiles([]);
                    setIsEditing(false);
                  } catch (err) {
                    console.error("Save error:", err);
                    toast.error("Failed to save changes");
                  } finally {
                    setIsSaving(false);
                  }
                }}
              >
                {isSaving ? "Saving..." : "Save Changes"}
              </Button>

              <Button
                variant="outline"
                disabled={isSaving}
                onClick={() => {
                  setEditData({
                    title: selectedTicket.title,
                    description: selectedTicket.description,
                    deployed_hours: selectedTicket.deployed_hours || 0,
                    resolved_hours: selectedTicket.resolved_hours || 0,
                  });
                  setNewFiles([]);
                  setAttachmentsList(selectedTicket.attachments || []);
                  setIsEditing(false);
                }}
              >
                Cancel
              </Button>
            </div>
          )}

        </div>

        <div className="flex flex-col items-end gap-2">
          <Badge className={getStatusColor(selectedTicket.status)}>{selectedTicket.status}</Badge>
          <Badge className={getPriorityColor(selectedTicket.priority)} variant="outline">
            {selectedTicket.priority}
          </Badge>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-4 text-sm">
        <div>
          <p className="text-gray-500">Created By</p>
          <p className="font-medium">{selectedTicket.created_by_name || "Unknown"}</p>
        </div>
        <div>
          <p className="text-gray-500">Assigned To</p>
          <p className="font-medium">
            {user.role === "client"
              ? "Hyperhex Developer"
              : selectedTicket.assigned_developer_name || "Not Assigned"}
          </p>
        </div>

        <div>
          <p className="text-gray-500">Created On</p>
          <p className="font-medium">{formatTimestamp(selectedTicket.created_at)}</p>
        </div>
        <div>
          <p className="text-gray-500">Due On</p>
          <p className="font-medium">{formatTimestamp(selectedTicket.due_date)}</p>
        </div>
        <div>
          <p className="text-gray-500">Last Updated</p>
          <p className="font-medium">{formatTimestamp(selectedTicket.updated_at || selectedTicket.created_at)}</p>
        </div>
        {selectedTicket.status === "Deployed" && selectedTicket.deployed_hours !== undefined && !isClient && (
          <div>
            <p className="text-gray-500">Deployed Hours</p>
            <p className="font-medium">{selectedTicket.deployed_hours} hrs</p>
          </div>
        )}
        {selectedTicket.status === "Resolved" && selectedTicket.resolved_hours !== undefined && !isClient && (
          <div>
            <p className="text-gray-500">Resolved Hours</p>
            <p className="font-medium">{selectedTicket.resolved_hours} hrs</p>
          </div>
        )}
      </div>

      <Separator />

      {/* <div>
        <h3 className="font-semibold mb-2">Description</h3>
        <p className="text-gray-700 whitespace-pre-wrap">{selectedTicket.description}</p>
      </div> */}
      <div>
        <h3 className="font-semibold mb-2">Description</h3>

        {isEditing ? (
          <>
            <Textarea
              rows={6}
              value={editData.description}
              onChange={(e) =>
                setEditData(p => ({ ...p, description: e.target.value }))
              }
            />
            {selectedTicket.status === "Deployed" && !isClient && (
              <div className="mt-4 max-w-xs">
                <Label htmlFor="edit-deployed-hours" className="text-sm font-semibold text-gray-700">Deployed Hours</Label>
                <Input
                  id="edit-deployed-hours"
                  type="number"
                  step="0.1"
                  min="0"
                  value={editData.deployed_hours}
                  onChange={(e) =>
                    setEditData(p => ({ ...p, deployed_hours: parseFloat(e.target.value) || 0 }))
                  }
                  className="mt-1"
                />
              </div>
            )}
            {selectedTicket.status === "Resolved" && !isClient && (
              <div className="mt-4 max-w-xs">
                <Label htmlFor="edit-resolved-hours" className="text-sm font-semibold text-gray-700">Resolved Hours</Label>
                <Input
                  id="edit-resolved-hours"
                  type="number"
                  step="0.1"
                  min="0"
                  value={editData.resolved_hours}
                  onChange={(e) =>
                    setEditData(p => ({ ...p, resolved_hours: parseFloat(e.target.value) || 0 }))
                  }
                  className="mt-1"
                />
              </div>
            )}
          </>
        ) : (
          <p className="text-gray-700 whitespace-pre-wrap">
            {selectedTicket.description}
          </p>
        )}
      </div>


      {/* Admin/Developer Actions */}
      {(isDeveloper || isAdmin) && (
        <div className="flex items-start gap-6 bg-gray-50 p-4 rounded-lg border">

          {/* Developer Reassign */}
          {isAdmin && (
            <div className="flex-1">
              <Label htmlFor="developer">Reassign Developer</Label>
              <Select
                value={selectedTicket.assigned_developer || "none"}
                onValueChange={(value) => {
                  if (value !== "none") {
                    handleUpdateDeveloper(selectedTicket.id, value);
                  }
                }}
              >
                <SelectTrigger>
                  <SelectValue placeholder="Select developer" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="none">None</SelectItem>
                  {developers.map((dev) => (
                    <SelectItem key={dev.id} value={dev.id}>
                      {dev.name}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
          )}

          {/* Status Update */}
          <div className="flex-1">
            <Label htmlFor="status">Update Status</Label>
            <Select
              value={selectedTicket.status}
              onValueChange={(value) => handleUpdateStatus(selectedTicket.id, value)}
            >
              <SelectTrigger data-testid="ticket-status-update-select">
                <SelectValue />
              </SelectTrigger>
              {/* <SelectContent>
                <SelectItem value="Open">Open</SelectItem>
                <SelectItem value="In Progress">In Progress</SelectItem>
                <SelectItem value="Resolved">Resolved</SelectItem>
                <SelectItem value="Rejected">Rejected</SelectItem>
              </SelectContent> */}
              <SelectContent>
                <SelectItem value="Open">Open</SelectItem>
                <SelectItem value="In Research">In Research</SelectItem>
                <SelectItem value="In Progress">In Progress</SelectItem>
                <SelectItem value="Blocked">Blocked</SelectItem>
                <SelectItem value="In QA">In QA</SelectItem>
                <SelectItem value="Rejected">Rejected</SelectItem>
                <SelectItem value="Resolved">Resolved</SelectItem>
                <SelectItem value="Deployed">Deployed</SelectItem>
              </SelectContent>

            </Select>
          </div>
        </div>
      )}
      <div className="mt-6 border-t pt-4">
        <h4 className="font-semibold mb-3">
          Attachments: {isEditing 
            ? (attachmentsList.length + newFiles.length === 0 ? "None" : `${attachmentsList.length + newFiles.length}`)
            : (selectedTicket.attachments?.length === 0 ? "None" : `${selectedTicket.attachments?.length}`)}
        </h4>

        {isEditing ? (
          <div className="space-y-4">
            {/* Existing attachments with remove buttons */}
            {attachmentsList.length > 0 && (
              <div className="space-y-2">
                <p className="text-sm font-medium text-gray-600">Existing Attachments:</p>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  {attachmentsList.map((attachment, index) => {
                    const fileUrl = getAttachmentUrl(attachment);
                    return (
                      <div key={index} className="flex justify-between items-center border rounded-lg p-3 hover:shadow-sm transition-shadow">
                        <div className="flex items-center space-x-2 truncate">
                          <Paperclip className="h-4 w-4 text-gray-400 shrink-0" />
                          <span className="text-sm truncate font-medium">{attachment.name}</span>
                        </div>
                        <Button
                          type="button"
                          variant="ghost"
                          size="sm"
                          className="text-red-500 hover:text-red-700 hover:bg-red-50 h-8 px-2"
                          onClick={() => setAttachmentsList(prev => prev.filter((_, i) => i !== index))}
                        >
                          Remove
                        </Button>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}

            {/* Dropzone for adding more attachments */}
            <div className="space-y-2">
              <p className="text-sm font-medium text-gray-600">Add More Attachments:</p>
              <div
                {...getEditRootProps()}
                className="border-2 border-dashed rounded-lg p-4 text-center cursor-pointer hover:border-gray-400 transition-colors bg-gray-50/50 hover:bg-gray-50"
              >
                <input {...getEditInputProps()} />
                <Paperclip className="mx-auto h-6 w-6 text-gray-400 mb-1" />
                <p className="text-xs text-gray-600">Drag files here or click to browse</p>
              </div>

              {newFiles.length > 0 && (
                <div className="mt-2 space-y-2">
                  {newFiles.map((f, idx) => (
                    <div key={idx} className="flex justify-between items-center text-sm border rounded-md px-3 py-2 bg-gray-50/30">
                      <span className="truncate">{f.name}</span>
                      <div className="flex items-center space-x-2 shrink-0">
                        <span className="text-xs text-gray-500">{(f.size / 1024 / 1024).toFixed(2)} MB</span>
                        <button
                          type="button"
                          onClick={() => setNewFiles(prev => prev.filter((_, i) => i !== idx))}
                          className="text-red-500 hover:text-red-700 font-medium text-xs ml-2"
                        >
                          Remove
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        ) : (
          /* Normal display of attachments (view mode) */
          <>
            {selectedTicket.attachments && selectedTicket.attachments.length > 0 && (
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {selectedTicket.attachments.map((attachment, index) => {
                  const fileUrl = getAttachmentUrl(attachment);
                  const isImage = attachment.mime?.startsWith("image/") || attachment.type === "image";

                  return (
                    <div key={index} className="border rounded-lg p-3 space-y-2 hover:shadow-sm transition-shadow">
                      {isImage && fileUrl ? (
                        <img
                          src={fileUrl}
                          alt={attachment.name}
                          className="w-full max-h-64 object-contain rounded-md border"
                        />
                      ) : null}

                      <a
                        href={fileUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center text-blue-600 hover:underline text-sm font-medium"
                      >
                        <Paperclip className="h-4 w-4 mr-2 shrink-0" />
                        {attachment.name || "File"}
                      </a>

                      <div className="text-xs text-gray-500">
                        {attachment.mime || ""} • {(attachment.size / 1024).toFixed(2)} KB
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </>
        )}
      </div>


      <Separator />

      <div>
        <h3 className="font-semibold mb-4">Comments ({visibleComments.length})</h3>

        <div className="space-y-4 mb-4 max-h-[30vh] overflow-y-auto pr-2">
          {visibleComments.length > 0 ? (
            visibleComments.map((comment) => {

                // -------------------------------------
                // 🔥 ROLE-BASED NAME MASKING STARTS HERE
                // -------------------------------------
                let displayText = comment.text;

                // Mask developer names inside system text for CLIENT
                if (user.role === "client") {
                  developers.forEach((dev, idx) => {
                    if (displayText.includes(dev.name)) {
                      displayText = displayText.replace(
                        dev.name,
                        "ht-dev-" + (idx + 1)
                      );
                    }
                  });

                  // Mask client name for developer
                  if (comment.user_role === "client") {
                    displayText = displayText.replace(comment.user_name, "Client");
                  }
                }

                // Mask client name for developer
                if (user.role === "developer" && comment.user_role === "client") {
                  displayText = displayText.replace(comment.user_name, "Client");
                }

                // Mask actual comment.user_name in UI
                let displayName = comment.user_name;

                // Hide developer names from CLIENT
                if (user.role === "client" && comment.user_role === "developer") {
                  const index = developers.findIndex(dev => dev.id === comment.user_id);
                  displayName = "ht-dev-" + (index + 1);
                  if (index === -1) displayName = "ht-dev";
                }

                // Hide client names from DEVELOPER
                if (user.role === "developer" && comment.user_role === "client") {
                  displayName = "Client";
                }
                // -------------------------------------
                // 🔥 ROLE-BASED NAME MASKING ENDS HERE
                // -------------------------------------

                return (
                  <div
                    key={comment.id}
                    className={`rounded-lg p-3 ${comment.system
                      ? "bg-indigo-50 border-l-4 border-indigo-400"
                      : comment.is_internal
                      ? "bg-yellow-50 border-l-4 border-yellow-400 dark:bg-yellow-950/20 dark:border-yellow-600"
                      : "bg-gray-50"
                      }`}
                  >
                    <div className="flex justify-between items-start mb-1">
                      <div>
                        <span
                          className={`font-semibold ${comment.system ? "text-indigo-800" : "text-gray-800"
                            }`}
                        >
                          {comment.system ? "System Update" : displayName}
                        </span>

                        {!comment.system && (
                          <Badge variant="outline" className="ml-2 text-xs">
                            {comment.user_role}
                          </Badge>
                        )}

                        {comment.is_internal && (
                          <Badge variant="secondary" className="ml-2 text-xs bg-yellow-100 text-yellow-800 hover:bg-yellow-100 border border-yellow-200">
                            Internal
                          </Badge>
                        )}
                      </div>

                      <span className="text-xs text-gray-500 shrink-0">
                        {formatTimestamp(comment.timestamp)}
                      </span>
                    </div>

                    {/* 🔥 FIXED HERE: NOW SHOWING MASKED TEXT */}
                    <p
                      className={`text-sm ${comment.system
                        ? "text-indigo-700 font-medium"
                        : "text-gray-700"
                        }`}
                    >
                      {displayText}
                    </p>
                  </div>
                );
              })
          ) : (
            <p className="text-gray-500 text-center py-4">No comments yet</p>
          )}
        </div>


        <div className="flex gap-2">
          <Input
            placeholder="Add a comment..."
            value={commentText}
            onChange={(e) => setCommentText(e.target.value)}
            onKeyPress={(e) => {
              if (e.key === "Enter" && commentText.trim()) {
                handleAddComment(isInternalComment);
                setIsInternalComment(false);
              }
            }}
            data-testid="comment-input"
          />
          <Button
            onClick={() => {
              handleAddComment(isInternalComment);
              setIsInternalComment(false);
            }}
            size="icon"
            data-testid="send-comment-btn"
            disabled={!commentText.trim()}
          >
            <Send className="h-4 w-4" />
          </Button>
        </div>
        {user?.role !== "client" && (
          <div className="flex items-center space-x-2 mt-2">
            <input
              type="checkbox"
              id="internal-comment-checkbox"
              checked={isInternalComment}
              onChange={(e) => setIsInternalComment(e.target.checked)}
              className="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500 cursor-pointer"
            />
            <label htmlFor="internal-comment-checkbox" className="text-xs text-gray-600 select-none cursor-pointer">
              Internal comment (visible only to developers and admins)
            </label>
          </div>
        )}
      </div>

    </div>
  );
};